import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import {
  MsalInterceptor, MsalService, MsalBroadcastService,
  MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MSAL_GUARD_CONFIG, MsalGuard
} from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from '../environments/environment';

import { routes } from './app.routes';

const BlueTheme = definePreset(Aura, {
  primitive: {
    primary: {
      50: '#e6f3fb',
      100: '#cce7f7',
      200: '#99cfef',
      300: '#66b7e7',
      400: '#33a0df',
      500: '#009dd9',
      600: '#007dbb',
      700: '#0066b2',
      800: '#0b2d71',
      900: '#09245a',
      950: '#061a42'
    }
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
          contrastColor: '#ffffff'
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}'
        }
      }
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    // MSAL
    {
      provide: MSAL_INSTANCE,
      useValue: new PublicClientApplication({
        auth: {
          clientId: environment.auth.clientId,
          authority: environment.auth.authority,
          redirectUri: environment.auth.redirectUri
        },
        cache: { cacheLocation: BrowserCacheLocation.LocalStorage }
      })
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useValue: {
        interactionType: InteractionType.Redirect,
        authRequest: { scopes: environment.auth.scopes }
      }
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useValue: {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          [`${environment.apiBaseUrl}/api`, environment.auth.scopes]
        ])
      }
    },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    providePrimeNG({
      theme: {
        preset: BlueTheme,
        options: {
          darkModeSelector: false
        }
      }
    })
  ]
};